module.exports = __webpack_public_path__ + "static/img/navajo.1c5f58b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/navajo.jpg
// module id = c0Yp
// module chunks = 1